import { Injectable, inject } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AppContextService, EcaSecurityService } from '@drc-eca/eca-components-lib';
import { map, switchMap } from 'rxjs/operators';
import { LocalSecurityService } from '../services/shared/local-security.service';

@Injectable({
  providedIn: 'root'
})
export class HasAppViewPermissionGuard implements CanActivate {
  private appContextSvc = inject(AppContextService);
  private ecaSecuritySvc = inject(EcaSecurityService);
  private localSecuritySvc = inject(LocalSecurityService);
  private router = inject(Router);


  appPermission: string = 'DRCPORTAL:eca-insight-status:admin';

  constructor(){

  }

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean>{
    return this.userHasPermission();
  }
  

  userHasPermission(): Observable<boolean>{
    return this.appContextSvc.getSelectedProductCode().pipe(
      switchMap((selectedClientCode): Observable<boolean>  => {
        if(sessionStorage.getItem('localSecurityOn') !== 'true'){
          return this.ecaSecuritySvc.userHasPermission(this.appPermission).pipe(
            map( hasPermission =>{            
             if(!hasPermission){
               sessionStorage.setItem('isAuthenticated', 'false');
               this.router.navigate(['/status/unauthorized']);
             }
             return hasPermission;
           }));
        }else {
          return this.localSecuritySvc.authenticateToken(JSON.parse(sessionStorage.getItem('ngStorage-ecatoken'))).pipe(
            map( data =>{            
             if(data['aclallow'].indexOf(this.appPermission) < 0 ){
                sessionStorage.setItem('isAuthenticated', 'false');
               this.router.navigate(['/status/unauthorized']);
             }
             return true;
           }));
        }
      }));  
  }

}